import React from "react";
import { InputNumber } from "antd";

const CustomNumberInput = ({
  value,
  onChange,
  isFixed = false,
  isPercentage = false,
  isEditing = true,
  min = 0,
  step = 1,
}) => {
  const handleChange = (val) => {
    if (val === undefined || val === null || val === "") {
      onChange(null);
      return;
    }

    let strVal = val.toString();
    const parts = strVal.split(".");
    if (parts.length === 2) {
      parts[1] = parts[1].slice(0, 2); // Limit to 2 decimal places
      strVal = parts.join(".");
    }

    const numVal = Number(strVal);
    if (!isNaN(numVal)) {
      onChange(numVal);
    } else {
      onChange(null);
    }
  };

  const onKeyDown = (e) => {
    const { key, currentTarget } = e;
    const val = currentTarget.value;

    if (key === "Enter") {
      e.preventDefault();
      return;
    }

    if (["e", "E", "+", "-"].includes(key)) {
      e.preventDefault();
      return;
    }

    if (key === "." && val === "") {
      // Allow leading decimal like ".66"
      return;
    }

    if (key === "." && val.includes(".")) {
      e.preventDefault();
      return;
    }

    if (key.length === 1 && !/[\d.]/.test(key)) {
      e.preventDefault();
      return;
    }

    const dotIndex = val.indexOf(".");
    if (dotIndex >= 0 && currentTarget.selectionStart > dotIndex) {
      const decimalPart = val.split(".")[1] || "";
      if (decimalPart.length >= 2 && /\d/.test(key)) {
        e.preventDefault();
        return;
      }
    }
  };

  return (
    <InputNumber
      min={min}
      step={step}
      precision={2}
      value={value}
      onChange={handleChange}
      onKeyDown={onKeyDown}
      style={{ width: "100%" }}
      disabled={!isEditing}
      prefix={isFixed ? "$" : undefined}
      suffix={isPercentage ? "%" : undefined}
    />
  );
};

export default CustomNumberInput;
